import { profile } from "./profile";
import { publications } from "./publications";
import { projects } from "./projects";

export const workLinks = [
  { href: "https://www.att.com", label: "Associate Network Engineer – AT&T" },
  {
    href: "https://www.lumen.com",
    label: "Associate Network Engineer – Lumen Technologies",
  },
  {
    href: "https://www.kingland.com",
    label: "Advanced Software Engineer Intern – Kingland",
  },
  {
    href: "https://www.nbc-2.com/article/florida-fgcu-homeland-security-combat-human-trafficking/60822403",
    label: "Senior Project – FGCU & HSI",
  },
  {
    href: "https://orcid.org/0009-0000-8685-0644",
    label: "Research & Teaching Assistant – FGCU",
  },
];

// Every project from the Projects grid, plus repos that only live here.
export const projectLinks = [
  ...projects.map(({ href, title }) => ({ href, label: title })),
  {
    href: "https://github.com/PauloDrefahl/Drone-Management-Platform",
    label: "Drone Management Software",
  },
];

// Short labels: the full paper titles are too long for the 384px sidenav.
export const publicationLinks = publications.map(({ href, shortTitle }) => ({
  href,
  label: shortTitle,
}));

export const reachMe = [profile.location, profile.phone, profile.email];
